module.exports = __webpack_public_path__ + "static/img/017.328450fb.jpg";